import { FunctionComponent, useLayoutEffect, useState } from 'react';
import { Group, Object3D } from 'three';
import { useBloomSelectionContext } from '@/context/BloomSelectionContext';

type Props = {
    enabled: boolean;
};

/**
 * Because the @react-three/postprocessing is stright trash
 */
export const SelectBloom: FunctionComponent<Props> = ({ enabled, children }) => {
    const [ref, setRef] = useState<Group | null>(null);
    const { setSelections } = useBloomSelectionContext();

    const meshes: Object3D[] = [];
    if (enabled) {
        ref?.traverse((o) => {
            if (o.type === 'Mesh') {
                meshes.push(o);
            }
        });
    }

    const ids = meshes.map((m) => m.uuid).join(',');
    useLayoutEffect(() => {
        if (!enabled) {
            return;
        }

        setSelections((current) => [...current.filter((o) => !meshes.some((m) => m.uuid === o.uuid)), ...meshes]);

        return () => {
            setSelections((current) => current.filter((o) => !meshes.some((m) => m.uuid === o.uuid)));
        };
    }, [ids, enabled, setSelections]); // eslint-disable-line react-hooks/exhaustive-deps

    return <group ref={setRef}>{children}</group>;
};
